import { Sender } from "../components/Sender";

export type SenderUserSelection = {
	/** Distinct users with at least one active sender. */
	selected: number;
	/** Distinct users present in the sender list. */
	total: number;
};

/**
 * Counts how many distinct sending *users* have at least one active sender, out
 * of the total distinct users in the list. Channels are ignored — a user with
 * several channels (LinkedIn + multiple emails) counts once, and counts as
 * "selected" as soon as any one of their channels is active. Drives the "X/Y"
 * badge on the Senders tab of the create/edit campaign modals.
 */
export const countSelectedSenderUsers = (senders: Sender[]): SenderUserSelection => {
	const totalUsers = new Set<number>();
	const selectedUsers = new Set<number>();

	for (const sender of senders) {
		totalUsers.add(sender.userId);

		if (sender.active) {
			selectedUsers.add(sender.userId);
		}
	}

	return { selected: selectedUsers.size, total: totalUsers.size };
};
